import React from 'react';
import UserSearchIcon from 'assets/icons/UserSearchIcon';
import CompassIcon from 'assets/icons/CompassIcon';
import UsersIcon from 'assets/icons/UsersIcon';
import FileAttachmentIcon from 'assets/icons/FileAttachmentIcon';
import HeartIcon from 'assets/icons/HeartIcon';
import HolidayIcon from 'assets/icons/HolidayIcon';
import LuggageIcon from 'assets/icons/LuggageIcon';
import StopWatchIcon from 'assets/icons/StopWatchIcon';
import DesignToolsIcon from 'assets/icons/DesignToolsIcon';
import BriefCaseIcon from 'assets/icons/BriefCaseIcon';
import BankIcon from 'assets/icons/BankIcon';
import FileDollarIcon from 'assets/icons/FileDollarIcon';
import WalletIcon from 'assets/icons/WalletIcon';
import ClockIcon from 'assets/icons/ClockIcon';
import PaperClipIcon from 'assets/icons/PaperClipIcon';
import CheckDoubleIcon from 'assets/icons/CheckDoubleIcon';
import Chat2Icon from 'assets/icons/Chat2Icon';
import OfficeChairIcon from 'assets/icons/OfficeChairIcon';
import Wallet2Icon from 'assets/icons/Wallet2Icon';
import PieChartIcon from 'assets/icons/PieChartIcon';

const linkIcons = {
  dashboard: <CompassIcon />,
  employees: <UsersIcon />,
  hr: <UserSearchIcon />,
  agreements: <FileAttachmentIcon />,
  benefits: <HeartIcon />,
  holidays: <HolidayIcon />,
  holidaysManagement: <LuggageIcon />,
  workingHours: <StopWatchIcon />,
  projects: <DesignToolsIcon />,
  clients: <BriefCaseIcon />,
  transactions: <BankIcon />,
  invoices: <FileDollarIcon />,
  contractors: <WalletIcon />,
  paymentDue: <ClockIcon />,
  budget: <PieChartIcon />,
  transactionAttachments: <PaperClipIcon />,
  responsibilities: <CheckDoubleIcon />,
  feedback: <Chat2Icon />,
  propertyBooking: <OfficeChairIcon />,
  accountancy: <Wallet2Icon />,
};

export default linkIcons;
